// Move an array item from one index to another (returns a new array).
export function arrayMove(list, from, to) {
  const a = list.slice();
  if (from < 0 || from >= a.length || to < 0 || to >= a.length) return a;
  const [item] = a.splice(from, 1);
  a.splice(to, 0, item);
  return a;
}
